/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2.5 6.99988H21.5M16.3 2.49988L19 6.99988M10.5 1.99988L13.5 6.99988M5.5 2.49988L8 6.99988M7.5 16.9999C7.5 17.276 7.27614 17.4999 7 17.4999C6.72386 17.4999 6.5 17.276 6.5 16.9999M7.5 16.9999C7.5 16.7237 7.27614 16.4999 7 16.4999C6.72386 16.4999 6.5 16.7237 6.5 16.9999M7.5 16.9999H6.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 7H22V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V7Z"
				fill="currentColor"
			/>
			<path
				d="M2.5 7H21.5M16.2998 2.5L18.9998 7M10.5 2L13.5 7M5.5 2.5L8 7M7.5 17C7.5 17.2761 7.27614 17.5 7 17.5C6.72386 17.5 6.5 17.2761 6.5 17M7.5 17C7.5 16.7239 7.27614 16.5 7 16.5C6.72386 16.5 6.5 16.7239 6.5 17M7.5 17H6.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 1.24999H10.4863C10.495 1.24984 10.5036 1.24984 10.5123 1.24999H14L14.0336 1.24999C15.4053 1.24999 16.4807 1.24998 17.3451 1.3206C18.2252 1.39251 18.9523 1.54137 19.6104 1.8767C20.6924 2.42798 21.572 3.30761 22.1233 4.38955C22.4586 5.04768 22.6075 5.77479 22.6794 6.65493C22.75 7.51926 22.75 8.59468 22.75 9.96636V9.96641V9.99999V14V14.0336V14.0336C22.75 15.4053 22.75 16.4807 22.6794 17.3451C22.6075 18.2252 22.4586 18.9523 22.1233 19.6104C21.572 20.6924 20.6924 21.572 19.6104 22.1233C18.9523 22.4586 18.2252 22.6075 17.3451 22.6794C16.4807 22.75 15.4053 22.75 14.0336 22.75H14.0336H14H10H9.96642H9.96637C8.59469 22.75 7.51927 22.75 6.65494 22.6794C5.7748 22.6075 5.04769 22.4586 4.38955 22.1233C3.30762 21.572 2.42798 20.6924 1.87671 19.6104C1.54138 18.9523 1.39252 18.2252 1.32061 17.3451C1.24999 16.4807 1.25 15.4053 1.25 14.0336V14.0336V14V9.99999V9.96643V9.96642C1.25 8.59471 1.24999 7.51928 1.32061 6.65493C1.39252 5.77479 1.54138 5.04768 1.87671 4.38955C2.42798 3.30761 3.30762 2.42798 4.38955 1.8767C5.04769 1.54137 5.7748 1.39251 6.65494 1.3206C7.51929 1.24998 8.59472 1.24999 9.96644 1.24999L10 1.24999ZM12.1754 6.24999L10.0754 2.74999H10C8.58749 2.74999 7.57322 2.75057 6.77708 2.81562C6.69698 2.82217 6.61977 2.82932 6.54527 2.83712L8.4413 6.24999H12.1754ZM3.21322 5.07053C3.61641 4.27923 4.25724 3.63433 5.04543 3.22611L6.72536 6.24999H2.87341C2.94512 5.74863 3.05453 5.38198 3.21322 5.07053ZM20.7868 5.07053C20.9455 5.38198 21.0549 5.74863 21.1266 6.24999H19.4246L17.3719 2.82883C18.0754 2.89627 18.5446 3.01711 18.9295 3.21321C19.7291 3.62068 20.3793 4.27084 20.7868 5.07053ZM15.6569 2.88586L17.6754 6.24999H13.9246L11.8246 2.74999H14C14.5985 2.74999 15.1254 2.7501 15.5946 2.75516C15.6108 2.79983 15.6315 2.84359 15.6569 2.88586ZM9 16.4999C9 17.3283 8.32843 17.9999 7.5 17.9999C6.67157 17.9999 6 17.3283 6 16.4999C6 15.6715 6.67157 14.9999 7.5 14.9999C8.32843 14.9999 9 15.6715 9 16.4999Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.49988V8.99988V8.99988C22 7.1386 22 6.20796 21.7553 5.45479C21.2607 3.9326 20.0673 2.73918 18.5451 2.2446C17.7919 1.99988 16.8613 1.99988 15 1.99988H10C7.19974 1.99988 5.79961 1.99988 4.73005 2.54485C3.78924 3.02421 3.02433 3.78911 2.54497 4.72993C2 5.79948 2 7.19962 2 9.99988V13.9999C2 16.8001 2 18.2003 2.54497 19.2698C3.02433 20.2106 3.78924 20.9755 4.73005 21.4549C5.79961 21.9999 7.19974 21.9999 10 21.9999H15C16.8613 21.9999 17.7919 21.9999 18.5451 21.7552C20.0673 21.2606 21.2607 20.0672 21.7553 18.545C22 17.7918 22 16.8612 22 14.9999V14.9999V14.4999M2.5 6.99988H10M21.5 6.99988H13.5L10.5 1.99988M16.2998 2.49988L18.9998 6.99988M5.5 2.49988L8 6.99988M7.5 16.9999C7.5 17.276 7.27614 17.4999 7 17.4999C6.72386 17.4999 6.5 17.276 6.5 16.9999M7.5 16.9999C7.5 16.7237 7.27614 16.4999 7 16.4999C6.72386 16.4999 6.5 16.7237 6.5 16.9999M7.5 16.9999H6.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2.5 7H21.5M16.2998 2.5L18.9998 7M10.5 2L13.5 7M5.5 2.5L8 7M7.5 17C7.5 17.2761 7.27614 17.5 7 17.5C6.72386 17.5 6.5 17.2761 6.5 17M7.5 17C7.5 16.7239 7.27614 16.5 7 16.5C6.72386 16.5 6.5 16.7239 6.5 17M7.5 17H6.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M1.25 6.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V6.25H1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.4863 1.25011H6.54545C3.62086 1.25011 1.25 3.62097 1.25 6.54557C1.25 7.21082 1.78929 7.75011 2.45455 7.75011H8H13.5H19H21.5455C22.2107 7.75011 22.75 7.21082 22.75 6.54557C22.75 3.62097 20.3791 1.25011 17.4545 1.25011H10.5123C10.5036 1.24996 10.495 1.24996 10.4863 1.25011ZM10.0754 2.75011L12.1754 6.25011H8.4413L6.49703 2.75042C6.51314 2.75021 6.52929 2.75011 6.54545 2.75011H10.0754ZM4.97047 3.09131C3.74529 3.65083 2.86967 4.84301 2.76133 6.25011H6.72536L4.97047 3.09131ZM13.9246 6.25011L11.8246 2.75011H15.5927C15.6092 2.79657 15.6305 2.84208 15.6569 2.88599L17.6754 6.25011H13.9246ZM19.4246 6.25011H21.2387C21.0879 4.29202 19.4513 2.75011 17.4545 2.75011H17.3246L19.4246 6.25011ZM5.75 17.0001C5.75 16.3098 6.30964 15.7501 7 15.7501C7.69036 15.7501 8.25 16.3098 8.25 17.0001C8.25 17.6905 7.69036 18.2501 7 18.2501C6.30964 18.2501 5.75 17.6905 5.75 17.0001Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
